import React, { useEffect, useState } from "react";
import io from "socket.io-client";
import NewsCard from "./NewsCard";
import { useLocation } from "react-router-dom";
import "./newsGride.css";
import MoreNews from "./MoreNews/MoreNews";
import MoreNewsCart from "./MoreNews/MoreNewsCart";

const socket = io.connect("https://mayapurapp.ap-1.evennode.com");

const News = () => {
  const [news, setNews] = useState([]);
  const { pathname } = useLocation();
      useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    socket.emit("retrieveHeadlineNews"); //on connection, request 16 news headlines
    socket.on("16NewsHeadlinesRetrieved", (dataObject) => {
      setNews(dataObject);
    });
    return () => {
      socket.off("16NewsHeadlinesRetrieved");
    };
  }, []);

    const firstTenNews = news.slice(0, 10);
  const remainingSixNews = news.slice(10);

  return (
    <div>

      {/* grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 justify-center  mx-auto */}
    
    <div className="content mx-2">
      {firstTenNews?.map((item , index) => (
        <NewsCard key={item._id} items={item} cart={`cart${index}`} />
      ))}
      </div>
           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-4 mx-2">
        {remainingSixNews.map((items) => (
          <MoreNewsCart key={items._id} item={items} />
        ))}
      </div>

      <MoreNews/>
      </div>
  );
};

export default News;
